<template>
  <div class="last_page_wrapper">
    <div class="icon_area">
      <div class="page_icon"></div>
    </div>
    <div class="text_area">
      <div class="thanx_title">
        {{ title }}
      </div>
      <div
        class="thanx_desc"
        v-html="$options.filters.newLineToBr(description)"
      ></div>
      <div class="cta_wrapper">
        <router-link :to="{ name: 'home' }">
          Anasayfaya dön >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepThanks',
  computed: {
    isApproved() {
      return this.$store.getters['supplier/getIsApproved'];
    },
    title() {
      if (this.isApproved) return 'TEBRİKLER, BAŞVURUNUZ ONAYLANDI!';
      else return 'TEBRİKLER, TEDARİKÇİMİZ OLMAK İÇİN İLK ADIMI ATTINIZ!';
    },
    description() {
      if (this.isApproved)
        return 'Başvurunuz onaylanmıştır.\n Lütfen e-posta kutunuzu kontrol ediniz.';
      else
        return 'Başvurunuzu aldık,\n2022 yeni tedarikçi açılış süreci başladığında sizlerle iletişime geçiyor olacağız.\nİlginiz için teşekkür ederiz!';
    },
  },
};
</script>
